<script lang="ts" setup>
import type { LayoutHeaderProps } from './types';

import BasicHeader from './basic-header.vue';

defineProps<LayoutHeaderProps>();
</script>

<template>
  <div>
    <BasicHeader :title="title" :description="description" :sticky="sticky">
      <template #actions>
        <slot name="actions" />
      </template>
    </BasicHeader>

    <div>
      <slot />
    </div>
  </div>
</template>
